import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import {
  TheDifferenceContainer,
  SectionHeader,
  HeaderWrap,
  DescriptionWrap,
  ContentWrap,
  ImageContainer,
  ClaimsContainer,
  ClaimBlock,
  ClaimTitle,
  ClaimBody,
} from './TheDifference.styles'
import rawCuts from '../../../../../public/assets/home/live-better.webp'
import { AlignedList } from 'components/AlignedList'

type TheDifferenceProps = {}

export const TheDifference: React.FC<TheDifferenceProps> = () => {
  const { t } = useTranslation()

  const featuresList = [
    <ClaimBlock key="1">
      <ClaimTitle>{t('raw-food-subscription:difference.meal.title')}</ClaimTitle>
      <ClaimBody>{t('raw-food-subscription:difference.meal.description')}</ClaimBody>
    </ClaimBlock>,

    <ClaimBlock key="2">
      <ClaimTitle>{t('raw-food-subscription:difference.nutritious.title')}</ClaimTitle>
      <ClaimBody>{t('raw-food-subscription:difference.nutritious.description')}</ClaimBody>
    </ClaimBlock>,

    <ClaimBlock key="3">
      <ClaimTitle>{t('raw-food-subscription:difference.safety.title')}</ClaimTitle>
      <ClaimBody>{t('raw-food-subscription:difference.safety.description')}</ClaimBody>
    </ClaimBlock>,
  ]

  return (
    <TheDifferenceContainer as="section" aria-labelledby="difference-heading">
      <HeaderWrap>
        <SectionHeader id="difference-heading">
          {t('raw-food-subscription:difference.title')}
        </SectionHeader>
      </HeaderWrap>

      <DescriptionWrap>
        <Text as="p" size="headline" color="accent-black" align="center">
          {t('raw-food-subscription:difference.subtitle')}
        </Text>
      </DescriptionWrap>

      <ContentWrap>
        <ImageContainer>
          <Image src={rawCuts} alt={t('raw-food-subscription:difference.alt')} priority />
        </ImageContainer>

        <ClaimsContainer>
          <AlignedList paddingY={21} listElements={featuresList} />
        </ClaimsContainer>
      </ContentWrap>
    </TheDifferenceContainer>
  )
}

export default TheDifference
